var dust = require('dustjs-linkedin');
(function(dust){dust.register("settings-settingIframe",body_0);function body_0(chk,ctx){return chk.w("<div class=\"iframe-container iframe-").f(ctx.get(["name"], false),ctx,"h").w("-container overlay-wrapper\">").p("topNavigationOverlay",ctx,ctx,{"title":ctx.get(["title"], false),"back":ctx.get(["back"], false),"close":ctx.get(["close"], false)}).w("<div class=\"about-main overlay-main\"><iframe  src=\"").f(ctx.get(["iframe"], false),ctx,"h").w("\" width=\"100%\" height=\"100%\"></iframe></div></div>");}body_0.__dustBody=!0;return body_0}(dust));
module.exports = 'settings-settingIframe';


//////////////////
// WEBPACK FOOTER
// ./src/common/templates/settings/settingIframe.dust
// module id = 414
// module chunks = 0 1